import './AppHeader.scss';
import { resolveBranding } from '../../config/branding';

function AppHeader({ branding: brandingData }) {
  const branding = resolveBranding(brandingData);

  return (
    <header className="app-header mb-4 d-flex align-items-center">
      <div className="container">
        <img src={branding.logo} height="60" alt={`${branding.companyName} Logo`} />
      </div>
    </header>
  );
}

export default AppHeader;
